export type Expertise = {
  title: string;
  summary: string;
  missions: string[];
};

export const expertises: Expertise[] = [
  {
    title: 'Stratégies et politiques locales de l’habitat',
    summary:
      'Élaboration et évaluation des PLH, PDH et volets habitat des PLUi, observatoires et stratégies foncières.',
    missions: ['Programme local de l’habitat', 'Observatoire de l’habitat', 'Stratégie foncière'],
  },
  {
    title: 'Renouvellement urbain',
    summary:
      'Conduite des projets NPNRU, études urbaines et sociales, conventions pluriannuelles et suivi des engagements.',
    missions: ['Protocole et convention ANRU', 'Études de peuplement', 'Gestion urbaine de proximité'],
  },
  {
    title: 'Amélioration de l’habitat privé',
    summary:
      'Études pré-opérationnelles et suivi-animation d’OPAH, de PIG et de plans de sauvegarde des copropriétés.',
    missions: ['OPAH-RU et PIG', 'Copropriétés en difficulté', 'Lutte contre l’habitat indigne'],
  },
  {
    title: 'Revitalisation des centres anciens',
    summary:
      'Accompagnement des programmes Action Cœur de Ville et Petites Villes de Demain, ORT et projets de territoire.',
    missions: ['Opération de revitalisation (ORT)', 'Diagnostic commercial et résidentiel', 'Plan guide'],
  },
  {
    title: 'Assistance à maîtrise d’ouvrage',
    summary:
      'Pilotage, coordination partenariale et montage financier des opérations pour le compte des maîtres d’ouvrage publics.',
    missions: ['Pilotage de programme', 'Montage financier', 'Concertation et participation'],
  },
];
